import React from 'react';
import { css, keyframes, Global, ClassNames, ThemeContext, jsx } from '@emotion/core';
import { default as emotionStyled, CreateStyled } from '@emotion/styled';
import { ThemeProvider, withTheme } from '@match/react-component-library';
import { Theme as RCLTheme } from '@match/react-component-library/components/theme/types/theme';
import { getThemeForSite } from './theme-helper';
import { Branding } from './brands';

export interface Theme extends RCLTheme {
  branding: Branding;
}

export function useTheme<T extends Theme>() {
  return React.useContext(ThemeContext) as T;
}

const styled = emotionStyled as CreateStyled<Theme>;

export type WithThemeProps<P> = P & { theme: Theme };

/**
 * Wraps 3rd party libraries.
 * 1. Incase we need to replace emotion with a similar api.
 * 2. Incase Emotion exports change. Emotion 11 contains named export changes.
 * 3. Apply Theme typings for useTheme(), and styled() globally.
 * 4. Uniformity with matchnode
 */
export { ClassNames, css, getThemeForSite, Global, jsx, keyframes, ThemeProvider, withTheme };

export default styled;
